// Busca de municípios brasileiros via API pública do IBGE.
// Endpoint: https://servicodados.ibge.gov.br/api/v1/localidades/estados/{UF}/municipios
// O `id` retornado é o código IBGE de 7 dígitos exigido pela SEFAZ.

const IBGE_BASE = 'https://servicodados.ibge.gov.br/api/v1/localidades/estados';

// Cache por sessão: Map<UF, Promise<[{id, nome}]>>.
// Cacheia a Promise para deduplicar chamadas paralelas durante o primeiro fetch.
const cache = new Map();

/**
 * Busca municípios de uma UF, com cache em memória.
 * Retorna [{ id: '3552403', nome: 'Taboão da Serra' }, ...] já ordenado por nome.
 * Lança Error se a chamada falhar (caller decide o fallback de UI).
 */
export function buscarMunicipios(uf) {
  const ufNorm = (uf || '').trim().toUpperCase();
  if (!ufNorm || ufNorm.length !== 2) {
    return Promise.reject(new Error('UF inválida'));
  }

  if (cache.has(ufNorm)) return cache.get(ufNorm);

  const promise = fetch(`${IBGE_BASE}/${ufNorm}/municipios`)
    .then(r => {
      if (!r.ok) throw new Error(`IBGE HTTP ${r.status}`);
      return r.json();
    })
    .then(arr => arr
      .map(m => ({ id: String(m.id), nome: m.nome }))
      .sort((a, b) => a.nome.localeCompare(b.nome, 'pt-BR'))
    )
    .catch(err => {
      // Não cacheia falha — permite nova tentativa
      cache.delete(ufNorm);
      throw err;
    });

  cache.set(ufNorm, promise);
  return promise;
}

/** Limpa o cache (uso opcional em testes / forçar re-fetch). */
export function limparCacheMunicipios() {
  cache.clear();
}
